import { createFileRoute } from '@tanstack/react-router';
import { CheckCircle2 } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export const Route = createFileRoute('/upload/success')({
  component: UploadSuccessPage,
});

function UploadSuccessPage() {
  return (
    <Card className="border-green-200">
      <CardHeader className="text-center">
        <div className="mx-auto mb-4 h-16 w-16 rounded-full bg-green-100 flex items-center justify-center">
          <CheckCircle2 className="h-10 w-10 text-green-600" />
        </div>
        <CardTitle className="text-green-700 text-2xl">Upload Successful!</CardTitle>
        <CardDescription className="text-base">
          Your documents have been securely uploaded.
        </CardDescription>
      </CardHeader>
      <CardContent className="text-center space-y-4">
        <p className="text-muted-foreground">
          The requester has been notified and will review your documents shortly.
        </p>
        <p className="text-sm text-muted-foreground">You can safely close this page.</p>
      </CardContent>
    </Card>
  );
}
